export default __webpack_public_path__ + "static/media/dashboard_01.1e80758a.jpg";